// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store/store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui'
import './assets/css/theme-chalk/index.css'
import './assets/css/common.css'
// require styles
import 'swiper/dist/css/swiper.css'
import dialog from './components/common/dialog/dialog.vue'
import VueLazyload from 'vue-lazyload'
import { getCookie } from './util/util'
import { clearCookie } from './util/celecookie'
import clickoutside from './assets/js/directive'
import verify from 'vue-verify-plugin'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'e4nogcRyySCUDSk9z4jz4xvh'
})
Vue.use(verify, {
  blur: true
})

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/noGoods.png',
  loading: '/static/noGoods.png',
  attempt: 1
})

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(clickoutside)

Vue.component('myDialog', dialog)

Vue.config.productionTip = false
/**
 * 路由跳转
 * @param next 路由
 */
// function nextRoute (next) {
//   // 线上
//  //  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
//   // next({path: v.templatepresall})
//   // 线下
//   next()
// }

/**
 * 路由过滤
 */
router.beforeEach((to, from, next) => {
  window.console.log = function ()  {
  }
  // if (to.name == '错误页404') {
  //   next()
  // }
  window.scrollTo(0, 0)
  // 线上
   let loc = location.host
  // 线下
 //  let loc = 'trace.cutmall.cn'
  if (getCookie('allreqdomain') === '' || getCookie('allreqdomain') === 'undefined') { // 尚未初始化
    initComyinfo(loc, next);
  } else { // 已初始化完成
    let allreqdomain = JSON.parse(getCookie('allreqdomain'))
    store.state.logoimgurl = JSON.parse(getCookie('logoimgurl'))
    store.state.allreqdomain = JSON.parse(getCookie('allreqdomain'))
    let maindomain = allreqdomain.maindomain.pc // pc商城主体域名
    let preselldomain = allreqdomain.preselldomain.pc // pc预售板块域名
    let tracedomain = allreqdomain.tracedomain.pc // pc溯源板块域名
    let websitedomain = allreqdomain.websitedomain.pc // pc企业官网域名
    let alldomain = `${maindomain},${preselldomain},${tracedomain},${websitedomain}`
    if (alldomain.includes(loc)) { // 判断域名是否包含在企业信息里
       next()
    } else { // 不包含时重新初始化公司信息
      clearCookie()
      initComyinfo(loc, next);
    }
  }
})

/**
 * 初始化公司信息
 * @param loc 域名
 * @param next 路由
 */
function initComyinfo (loc, next) {
  let reqDomainparams = {
    reqdomain: loc,
    terminaltype: 0
  }
  store.dispatch('CmpyinfoByReqdomain', reqDomainparams).then(res => {
    if (res.data.status == '001') {
      // store.dispatch('getSysmarinfo')
      // store.dispatch('getPubordprintinfo')
      // store.state.logoimgurl = JSON.parse(getCookie('logoimgurl'))
      // store.state.allreqdomain = getCookie('allreqdomain')
      next()
    }
  }).catch(function () {
    next();
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js